module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai218-fba380a94783cd62289fff2c1a71e494.jpg";